import React, { Component } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    Slide,
    IconButton,
    Typography
} from '@material-ui/core'
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[400],
    },
});

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

class ParamsDetailsDialog extends Component {

    render() {

        return (
            <Dialog onClose={() => this.props.onClose()} open={this.props.isOpen} TransitionComponent={Transition}>
                <DialogTitle className="dialog-header-custom" onClose={this.props.onClose}>{this.props.t("params_details")} </DialogTitle>
                <DialogContent>
                    <pre>
                        {JSON.stringify(this.props.selectedParams, null, 2)}
                    </pre>
                </DialogContent>
                <DialogActions>
                    <Button color="inherit" variant="contained" onClick={() => this.props.onClose()}>
                        {this.props.closeButtonTitle}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default withTranslation()(ParamsDetailsDialog);
